<button [type]="type" [disabled]="disabled" class="btn {{padding}} btn-gray-{{color}} fw-{{weight}} {{customClass}}" [class.w-100]="fullWidth">
  <gray-icon *ngIf="preIcon && preIcon !== ''" [icon]="preIcon"></gray-icon>
  <div *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
  {{text}}
  <ng-content *ngIf="!isLoading" ></ng-content>
  <gray-icon *ngIf="postIcon && postIcon !== ''" [icon]="postIcon"></gray-icon>
</button>
